import type { ReactElement } from "react";
import { useCallback, useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Dropdown, EllipsisDropdownItem, IconButton } from "@similarweb/ui-components";

type Props = {
    onEdit?: (isEditing: boolean) => void;
    onDelete?: () => void;
};

export const GoogleMarketActions = ({ onEdit, onDelete }: Props) => {
    const { translate } = useTranslate();

    const actions = useMemo(() => {
        const arr: ReactElement[] = [];
        if (onEdit) {
            arr.push(
                <EllipsisDropdownItem
                    key="edit"
                    id="edit"
                    iconName="settings"
                    iconSize="sm"
                >
                    {translate("global.edit")}
                </EllipsisDropdownItem>,
            );
        }
        if (onDelete) {
            arr.push(
                <EllipsisDropdownItem
                    key="delete"
                    id="delete"
                    iconName="delete"
                    iconSize="sm"
                >
                    {translate("global.delete")}
                </EllipsisDropdownItem>,
            );
        }
        return arr;
    }, [onDelete, onEdit, translate]);

    const handleClick = useCallback(
        (item: { id?: string }) => {
            if (item.id === "edit") {
                onEdit?.(true);
            }
            if (item.id === "delete") {
                onDelete?.();
            }
        },
        [onEdit, onDelete],
    );

    if (actions.length === 0) {
        return null;
    }

    return (
        <div data-automation="gsc-market-actions">
            <Dropdown
                width={200}
                dropdownPopupPlacement="ontop-right"
                appendTo="body"
                closeOnItemClick
                onClick={handleClick}
            >
                <IconButton
                    iconName="dots-more"
                    type="flat"
                    iconSize="xs"
                />
                {...actions}
            </Dropdown>
        </div>
    );
};
